<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="oncapture ? 'show' : 'show'" :style="oncapture ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-camera"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Fotografias del Paquete</h5>
                            <small class="d-block text-xs text-muted">Archivo desde la cámara web</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="vstack gap-3">
                            <div>
                                <camera :closecamare="closecamare" @capture="CAPTURE" @closeerror="$emit('close')"></camera>
                            </div>
                            <div class="row">
                                <div class="col-md-4 mb-2 position-relative" v-for="(item, index) in images">
                                    <img :src="`${item.path}`" class="img-fluid">
                                    <button type="button" @click="REMOVE(index)"
                                        class="btn btn-m position-absolute cursor-point btn-danger rounded-circle"
                                        style="right: -2px; top: -8px;">
                                        <i class="fa-solid fa-close"></i>
                                    </button>
                                    <a :href="item.path" target="_blank" rel="noopener noreferrer">{{ item.name }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-success px-3" :disabled="images.length == 0" @click="SAVE()">Guardar fotografias tomadas</button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="CLOSE()">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: {
        oncapture: {
            type: Boolean,
        },
        data: {
            type: Object
        }
    },
    data(){
        return{
            closecamare: false,
            images: [],
        }
    },
    methods:{
        CLOSE: function(){
            let vue = this
            vue.closecamare = true
            setTimeout(() => {
                if(vue.closecamare){
                    vue.$emit('onclose')
                }
            }, 100)
        },
        CAPTURE: function(canvas){
            this.images.push(canvas)
        },
        REMOVE: function (index) {
            if (this.images) {
                this.images.splice(index, 1)
            }
        },
        SAVE: function(){
            let vue = this
            vue.closecamare = true
            setTimeout(() => {
                if(vue.closecamare){
                    vue.$emit('save', this.images)
                }
            }, 100)
        }
    }
}
</script>